import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Driver, driverToString } from "src/services/driver/driver.interface";

@Component({
  selector: "rc-driver-search-result",
  templateUrl: "./driver-search-result.component.html",
  styleUrls: ["./driver-search-result.component.scss"],
  standalone: false,
})
export class DriverSearchResultComponent {
  @Input() public driver: Driver;
  @Output() onClick = new EventEmitter<Driver>();

  constructor() {}

  public readonly driverToString = driverToString;
}
